import React from 'react';
import { Segment } from '~/Helpers/Segment.helper';
import { SegmentName } from '~/Constants/Segment.constants';
import { dateDiffInDays } from '~/Helpers/Date.helper';
import { useDateFns } from '~/Hooks';
import { IconButton, Typography } from '~/UIKit';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { useStyles } from './CalendarDatePickerNavigation.styles';

export interface IUseCalendarDatePickerNavigation {
  focusedDay: Date;
  onNext: () => void;
  onPrev: () => void;
}

export const useCalendarDatePickerNavigation = ({
  onNext,
  onPrev,
  focusedDay,
}: IUseCalendarDatePickerNavigation) => {
  const onNextClicked = () => {
    Segment.track(SegmentName.CALENDAR_NEXT, {
      category: 'Calendar',
      weeksIntoTheFuture: `${Math.ceil(dateDiffInDays(new Date(), focusedDay) / 7) + 1}`,
    });
    onNext();
  };
  const onPrevClicked = () => {
    Segment.track(SegmentName.CALENDAR_PREV, {
      category: 'Calendar',
      weeksIntoThePast: `${Math.ceil(dateDiffInDays(focusedDay, new Date()) / 7) - 1}`,
    });
    onPrev();
  };
  return { onNextClicked, onPrevClicked };
};

export interface CalendarNavigationProps {
  focusedDay: Date;
  onNext: () => void;
  onPrev: () => void;
}

export const CalendarDatePickerNavigation = ({
  onPrev,
  onNext,
  focusedDay,
}: CalendarNavigationProps) => {
  const { classes } = useStyles();
  const { formatDate } = useDateFns();
  const { onNextClicked, onPrevClicked } = useCalendarDatePickerNavigation({
    onNext,
    onPrev,
    focusedDay,
  });

  return (
    <div className={classes.container} data-testid="CalendarNavigationWrapper">
      <Typography className={classes.text}>
        {formatDate(focusedDay.toISOString(), 'LLLL yyyy')}
      </Typography>
      <div className={classes.weekMonthNavigation}>
        <IconButton className={classes.navigationButton} onClick={onPrevClicked} size="large">
          <KeyboardArrowLeft />
        </IconButton>
        <IconButton className={classes.navigationButton} onClick={onNextClicked} size="large">
          <KeyboardArrowRight />
        </IconButton>
      </div>
    </div>
  );
};
